var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmptyBenefitList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 115,
  height: 115,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 114,
  height: 114,
  rx: 57,
  fill: "#DF3637"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36.875 36.875v2.063a6.194 6.194 0 0 1-6.188 6.187h-2.062V65.75h2.063a6.194 6.194 0 0 1 6.187 6.187V74h41.25v-2.063a6.194 6.194 0 0 1 6.187-6.187h2.063V45.125h-2.063a6.194 6.194 0 0 1-6.187-6.188v-2.062h-41.25ZM40.791 41h20.834v4.125h4.125V41h8.46v.008c.829 4.015 4.024 7.188 8.04 8.016V61.85c-4.018.83-7.214 4.006-8.04 8.025h-8.46V65.75h-4.125v4.125H40.79c-.828-4.02-4.02-7.213-8.041-8.04V49.04c4.02-.828 7.213-4.02 8.04-8.041Zm20.834 8.25v4.125h4.125V49.25h-4.125Zm0 8.25v4.125h4.125V57.5h-4.125Z",
  fill: "#050503"
})));
export default SvgEmptyBenefitList;